import List, { ListItem } from "./product/pdp/List"
import PDPIconTextGrid, { PDPIconTextGridItem } from "./product/pdp/IconTextGrid"

import ABTest from "./utils/ABTest"
import AboTeaser from "../components-v2/new/form/selftest/abo-teaser"
import AboTeaserItem from "../components-v2/new/form/selftest/abo-teaser-item"
import AboutLaVita from "./image-text/AboutLaVita"
import BackToTop from "./components/layout/BackToTop"
import BasicImage from "./image/BasicImage"
import BasicText from "./text/BasicText"
import ButtonBrick from "./button/Button"
import CenterText from "./text/CenterText"
import ColumnCustomProduct from "./product/ColumnCustomProduct"
import ColumnQuote from "./quote/ColumnQuote"
import DecorativeText from "./decorative/DecorativeText"
import Divider from "./decorative/Divider"
import FAQ from "./faq/FAQ"
import FAQs from "./faq/FAQs"
import Faq from "./redesign/Faq"
import FaqItem from "./redesign/FaqItemRedesign"
import FootnoteItem from "./text/FootnoteItem"
import Footnotes from "./text/Footnotes"
import Form from "./form/form"
import FullWidthImageBreak from "./image/FullWidthImageBreak"
import FullWidthVideoBreak from "./video/FullWidthVideoBreak"
import GreenText from "./product/pdp/GreenText"
import GridIconText from "./icon-text/GridIconText"
import GridIconTextImage from "./icon-text/GridIconTextImage"
import HTML from "./html/html"
import HeadlineCircleText from "./text/HeadlineCircleText"
import HealthClaim from "./healthclaims/HealthClaim"
import Hero from "./hero/Hero"
import HeroArticle from "./hero/HeroArticle"
import HeroImageBox from "./hero/HeroImageBox"
import HeroIntro from "./hero/Intro"
import HeroRedesign from "./redesign/HeroRedesign"
import IconText from "./icon-text/IconText"
import IconTextGrid from "./icon-text/IconTextGrid"
import IconTextList from "./product/IconTextList"
import IconTextShadowCard from "./icon-text/IconTextShadowCard"
import IconTextShowMoreRedesign from "./redesign/IconTextShowMoreRedesign"
import IconTextShowMoreRedesignItem from "./redesign/IconTextShowMoreRedesignItem"
import IconTextSlider from "./icon-text/IconTextSlider"
import IconTwoColumnsText from "./icon-text/IconTwoColumnsText"
import IconTwoColumnsTextGrid from "./icon-text/IconTwoColumsTextGrid"
import ImageButton from "./button/ImageButton"
import ImageText from "./image-text/three-column/ImageText"
import ImageTextColumn from "./ImageTextColumn/ImageTextColumn"
import ImageTextColumnItem from "./ImageTextColumn/ImageTextColumnItem"
import ImageTextSlider from "./image-text/slider/ImageTextSlider"
import ImageTextSliderItem from "./image-text/slider/ImageText"
import InfoBoxes from "./info-boxes/InfoBoxes"
import Lock from "./utils/Lock"
import MasterColumnIconText from "./icon-text/MasterColumnIconText"
import MasterColumnQuote from "./quote/MasterColumnQuote"
import MasterImageTextCircle from "./image-text/MasterImageTextCircle"
import MasterTeaser from "./teaser/MasterTeaser"
import MatrixItem from "./product/matrix/Item"
import MatrixItemRow from "./product/matrix/Row"
import MatrixRedesignItem from "./redesign/matrix/Item"
import MatrixRedesignItemInfoBox from "./redesign/matrix/InfoBox"
import MatrixRedesignItemRow from "./redesign/matrix/Row"
import MatrixRedesignUsp from "./redesign/matrix/Usp"
import Nps from "./nps/Nps"
import NutritionTable from "./table/NutritionTable"
import PDP from "./product/PDP"
import PDPImage from "./product/pdp/Image"
import ProductCustom from "./product/ProductCustom"
import ProductIntro from "./image-text/ProductIntro"
import ProductMatrix from "./product/Matrix"
import ProductMatrixRedesign from "./redesign/MatrixRedesign"
import ProductRepeaterImage from "./product/ProductRepeaterImage"
import ProductTeaser from "./teaser/ProductTeaser"
import ProductTeaserItem from "./teaser/ProductTeaserItem"
import QuoteCompact from "./quote/QuoteCompact"
import Selftest from "../components-v2/new/form/selftest"
import Service from "./service/Service"
import ShowMore from "./show-more/ShowMore"
import SingleProduct from "./product/TabProduct"
import Smallprint from "./text/Smallprint"
import SmallprintItem from "./text/SmallprintItem"
import SpacerComponent from "./spacer/Spacer"
import StarsText from "./icon-text/StarsText"
import StickyHealthClaims from "./healthclaims/StickyHealthClaims"
import StickyProductBox from "./product/StickyProductBox"
import Stripe from "./stripe/Stripe"
import StripeIconText from "./stripe/StripeIconText"
import SubscriptionTeaser from "./teaser/SubscriptionTeaser"
import SuccessBox from "../components-v2/new/form/selftest/success-box"
import Summary from "./components/article/Summary"
import TabContent from "./tab/TabContent"
import TabContentItem from "./tab/TabContentItem"
import TabbedPDP from "./product/TabbedPDP"
import TabbedProducts from "./product/TabbedProducts"
import Table from "./table/Table"
import TableCell from "./table/TableCell"
import TableRow from "./table/TableRow"
import Teaser from "../components-v2/new/form/selftest/teaser"
import TeaserAccordion from "../components-v2/new/form/selftest/teaser-accordion"
import TestimonialBenefit from "./redesign/TestimonialBenefit"
import TestimonialCard from "./redesign/TestimonialCard"
import Testimonials from "./redesign/Testimonials"
import Text from "./text/Text"
import Text4ImagesBlock from "./redesign/Text4ImagesBlock"
import Text60Image40 from "./components/text-image/text-60-image-40"
import TextImageBlock from "./image-text/two-column/TextImageBlock"
import TextImageBlockRedesign from "./redesign/TextImageBlockRedesign"
import TextLinkBrick from "./text/TextLink"
import TextLinksShadowCard from "./text/TextLinksShadowCard"
import ThreeColumnBigIconText from "./icon-text/ThreeColumnBigIconText"
import ThreeColumnBigIconTextItem from "./icon-text/BigIconText"
import ThreeColumnCustomProducts from "./product/ThreeColumnCustomProducts"
import ThreeColumnImageList from "./image-text/three-column/ThreeColumnImageList"
import ThreeColumnImageListItem from "./image-text/three-column/ThreeColumnImageListItem"
import ThreeColumnImageText from "./image-text/three-column/ThreeColumnImageText"
import Trust from "./product/pdp/Trust"
import TrustReview from "./stripe/TrustReview"
import TrustReviewsStripe from "./stripe/TrustReviewsStripe"
import TrustStripe from "./stripe/TrustStripe"
import TwoColumnImageText from "./image-text/two-column/TwoColumnImageText"
import TwoColumnImageTextItem from "./image-text/two-column/ImageText"
import UKTeaser from "./teaser/UKTeaser"
import UspItemRedesign from "./redesign/UspItem"
import UspRedesign from "./redesign/Usp"
import VideoPlayer from "./video/VideoPlayer"
import { types } from "react-bricks/rsc"

const bricks: types.Theme[] = [
    {
        themeName: "LaVita Bricks",
        categories: [
            {
                categoryName: "Hero",
                bricks: [Hero, HeroIntro, HeroArticle, HeroRedesign],
            },
            {
                categoryName: "Image",
                bricks: [BasicImage],
            },
            {
                categoryName: "Text",
                bricks: [
                    BasicText,
                    HeadlineCircleText,
                    IconTextShadowCard,
                    TextLinksShadowCard,
                    Text,
                    TextLinkBrick,
                    Footnotes,
                    FootnoteItem,
                ],
            },
            {
                categoryName: "Video",
                bricks: [VideoPlayer, FullWidthVideoBreak],
            },
            {
                categoryName: "Text with Images",
                bricks: [
                    MasterImageTextCircle,
                    HeroImageBox,
                    Text60Image40,
                    TextImageBlock,
                    ProductIntro,
                    AboutLaVita,
                    Text4ImagesBlock,
                ],
            },
            {
                categoryName: "Columns with Images",
                bricks: [
                    TwoColumnImageText,
                    TwoColumnImageTextItem,
                    ThreeColumnImageText,
                    ImageTextColumn,
                    ThreeColumnImageList,
                    ThreeColumnImageListItem,
                    ThreeColumnBigIconText,
                    ImageTextColumnItem,
                    ThreeColumnBigIconTextItem,
                ],
            },
            {
                categoryName: "Columns with Icons",
                bricks: [
                    MasterColumnIconText,
                    ShowMore,
                    Stripe,
                    StripeIconText,
                    IconTwoColumnsTextGrid,
                    GridIconTextImage,
                    GridIconText,
                    IconText,
                    IconTextGrid,
                    IconTextList,
                    IconTwoColumnsText,
                    IconTextShowMoreRedesign,
                    IconTextShowMoreRedesignItem,
                    UspRedesign,
                    UspItemRedesign,
                ],
            },
            {
                categoryName: "Slider / Tabs",
                bricks: [
                    ImageTextSlider,
                    TabContent,
                    TabContentItem,
                    IconTextSlider,
                    ImageText,
                    ImageTextSliderItem,
                    Testimonials,
                    TestimonialCard,
                    TestimonialBenefit,
                ],
            },
            {
                categoryName: "Product Teaser",
                bricks: [MasterTeaser, FullWidthImageBreak, ProductTeaser, ProductTeaserItem, UKTeaser],
            },
            {
                categoryName: "Shop Modules",
                bricks: [
                    ProductMatrix,
                    MatrixItem,
                    MatrixItemRow,
                    ProductMatrixRedesign,
                    MatrixRedesignItem,
                    MatrixRedesignItemInfoBox,
                    MatrixRedesignItemRow,
                    MatrixRedesignUsp,
                    PDP,
                    PDPImage,
                    TabbedPDP,
                    StickyProductBox,
                    SubscriptionTeaser,
                    ThreeColumnCustomProducts,
                    ProductCustom,
                    ProductRepeaterImage,
                    TabbedProducts,
                    ColumnCustomProduct,
                    PDPIconTextGrid,
                    PDPIconTextGridItem,
                    SingleProduct,
                ],
            },
            {
                categoryName: "FAQ",
                bricks: [FAQ, FAQs],
            },
            {
                categoryName: "Quote / Trust",
                bricks: [TrustStripe, TrustReviewsStripe, TrustReview, Trust, MasterColumnQuote, QuoteCompact],
            },
            {
                categoryName: "Forms",
                bricks: [Form, Selftest],
            },
            {
                categoryName: "Table",
                bricks: [Table, TableCell, TableRow, NutritionTable],
            },
            {
                categoryName: "Smallprint / Claims",
                bricks: [Smallprint, SmallprintItem, StickyHealthClaims],
            },
            {
                categoryName: "Contact",
                bricks: [InfoBoxes, Service],
            },
            {
                categoryName: "Others",
                bricks: [
                    Divider,
                    HTML,
                    ABTest,
                    ButtonBrick,
                    CenterText,
                    ColumnQuote,
                    DecorativeText,
                    GreenText,
                    HealthClaim,
                    ImageButton,
                    List,
                    ListItem,
                    Nps,
                    SpacerComponent,
                    StarsText,
                    BackToTop,
                    Summary,
                    AboTeaser,
                    AboTeaserItem,
                    SuccessBox,
                    Teaser,
                    TeaserAccordion,
                    TextImageBlockRedesign,
                    Faq,
                    FaqItem,
                    Lock,
                ],
            },
        ],
    },
]

export default bricks
